import $ from 'jquery';
import Filter from './Filter';

// Pagination
export default class PaginationFilter extends Filter {

  constructor($element, options) {
    super($element, options);

    if ($element.length === 0) return false;

    this.filterType = "PaginationFilter";

    console.log(this.getElement().selector + " a.page-numbers");

    $(".wjp-jobs").on('click', this.getElement().selector + " a.page-numbers", this.onClick.bind(this));
  }

  getValue() {
    if(!this.value) {
      this.value = $(this.getElement().selector).find(".page-numbers.current").html();
    }

    return (!this.value) ? false : this.value;
  }

  setValue(value) {
    this.value = value;
  }

  getKey() {
    return "paged";
  }

  onClick(ev) {
    ev.preventDefault();
    ev.stopPropagation();

    // Weird regex to get page number
    let slug = $(ev.target).attr('href').match(/page\/([\d]+)/i);
    slug = (slug && typeof slug[1] !== "undefined") ? slug[1] : "1";
    this.setValue(slug);

    $.messages.send({
      type: 'FILTER/VALUE_CHANGED',
      key: this.getKey(),
      value: this.getValue(),
      sender: this
    });
  }

}



/** WEBPACK FOOTER **
 ** ../assets/js/filters/PaginationFilter.js
 **/